import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Course Registration")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-6" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Sector name", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Select Option", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Agro Food processing", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Construction", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("option", { value: "3" }, "Healthcare", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", { value: "4" }, "ICT", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("option", { value: "5" }, "Leather and Footwear", -1)
const _hoisted_17 = { class: "col-md-4" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Course name", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Select Option", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, " Aluminium fabrication & Installation ", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Apparel Merchandising", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("option", { value: "3" }, "Auto Mechanics", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("option", { value: "4" }, "Banking Technology", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("option", { value: "5" }, "Basic Woven Structure", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("option", { value: "6" }, "Business Accounting", -1)
const _hoisted_27 = { class: "col-md-4" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Location", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Select Option", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Dhaka", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Barisal", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("option", { value: "3" }, "Bagerhat", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("option", { value: "4" }, "Bhola", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("option", { value: "5" }, "Bandarban", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("option", { value: "6" }, "chattogram", -1)
const _hoisted_37 = { class: "row mt-4" }
const _hoisted_38 = { class: "col-md-4" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_41 = ["label", "value"]
const _hoisted_42 = { class: "col-md-4" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Institute", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Select Option", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, " BASIS Institute of Technology and Management ", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("option", { value: "2" }, " BASIS Institute of Technology and Managemen - Chittagong ", -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("option", { value: "3" }, " Mirpur Agriculture Workshop and Training School -Mirpur ", -1)
const _hoisted_49 = { class: "card mb-5 mb-xl-10" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#employee_information",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Application Information")
  ])
], -1)
const _hoisted_51 = {
  id: "employee_information",
  class: "collapse show"
}
const _hoisted_52 = { class: "collapse show" }
const _hoisted_53 = { class: "card-body border-top p-9" }
const _hoisted_54 = { class: "row" }
const _hoisted_55 = { class: "col-md-3" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", { class: "form-label form-label-lg required" }, " NID No ", -1)
const _hoisted_57 = { class: "col-md-3" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Name", -1)
const _hoisted_59 = { class: "col-md-3" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Father Name", -1)
const _hoisted_61 = { class: "col-md-3" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, " Mother Name ", -1)
const _hoisted_63 = { class: "row mt-3" }
const _hoisted_64 = { class: "col-md-3" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Date of Birth")
], -1)
const _hoisted_66 = { class: "col-md-3" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Present Address")
], -1)
const _hoisted_68 = { class: "col-md-3" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Present District")
], -1)
const _hoisted_70 = ["label", "value"]
const _hoisted_71 = { class: "col-md-3" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Present Upazilla")
], -1)
const _hoisted_73 = ["label", "value"]
const _hoisted_74 = { class: "row mt-3" }
const _hoisted_75 = { class: "col-md-3" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Post Code")
], -1)
const _hoisted_77 = { class: "col-md-3" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Permanent Address")
], -1)
const _hoisted_79 = { class: "col-md-3" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Permanent District")
], -1)
const _hoisted_81 = ["label", "value"]
const _hoisted_82 = { class: "col-md-3" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Permanent Upazilla")
], -1)
const _hoisted_84 = ["label", "value"]
const _hoisted_85 = { class: "row mt-3" }
const _hoisted_86 = { class: "col-md-3" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold form-label required" }, "Trainer Image", -1)
const _hoisted_88 = { class: "card mb-5 mb-xl-10" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#personal_information",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Personal Information")
  ])
], -1)
const _hoisted_90 = {
  id: "personal_information",
  class: "collapse show"
}
const _hoisted_91 = { class: "collapse show" }
const _hoisted_92 = { class: "card-body border-top p-9" }
const _hoisted_93 = { class: "row" }
const _hoisted_94 = { class: "col-md-3" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Reference Id", -1)
const _hoisted_96 = { class: "col-md-3" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Mobile", -1)
const _hoisted_98 = { class: "col-md-3" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Alternative Mobile")
], -1)
const _hoisted_100 = { class: "col-md-3" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Email")
], -1)
const _hoisted_102 = { class: "row mt-3" }
const _hoisted_103 = { class: "col-md-3" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Ethnic Group")
], -1)
const _hoisted_105 = { class: "col-md-3" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Highest Class Completed")
], -1)
const _hoisted_107 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Select Option", -1)
const _hoisted_108 = /*#__PURE__*/_createElementVNode("option", { value: "Masters" }, "Masters", -1)
const _hoisted_109 = /*#__PURE__*/_createElementVNode("option", { value: "Bachelor" }, "Bachelor", -1)
const _hoisted_110 = /*#__PURE__*/_createElementVNode("option", { value: "HSC" }, "HSC", -1)
const _hoisted_111 = /*#__PURE__*/_createElementVNode("option", { value: "SSC" }, "SSC", -1)
const _hoisted_112 = { class: "col-md-3" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Passing Year")
], -1)
const _hoisted_114 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Select Option", -1)
const _hoisted_115 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, "1985", -1)
const _hoisted_116 = /*#__PURE__*/_createElementVNode("option", { value: "2" }, "1986", -1)
const _hoisted_117 = /*#__PURE__*/_createElementVNode("option", { value: "3" }, "1998", -1)
const _hoisted_118 = { class: "col-md-3" }
const _hoisted_119 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Is Employed?")
], -1)
const _hoisted_120 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Select Option", -1)
const _hoisted_121 = /*#__PURE__*/_createElementVNode("option", { value: "Y" }, "Yes", -1)
const _hoisted_122 = /*#__PURE__*/_createElementVNode("option", { value: "N" }, "No", -1)
const _hoisted_123 = { class: "row mt-3" }
const _hoisted_124 = { class: "col-md-3" }
const _hoisted_125 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Years of Experience")
], -1)
const _hoisted_126 = { class: "col-md-3" }
const _hoisted_127 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Personal Monthly Income")
], -1)
const _hoisted_128 = { class: "col-md-3" }
const _hoisted_129 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Home Distric")
], -1)
const _hoisted_130 = ["label", "value"]
const _hoisted_131 = { class: "col-md-3" }
const _hoisted_132 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Home Upazilla")
], -1)
const _hoisted_133 = ["label", "value"]
const _hoisted_134 = { class: "row mt-3" }
const _hoisted_135 = { class: "col-md-3" }
const _hoisted_136 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Remarks")
], -1)
const _hoisted_137 = { class: "col-md-3" }
const _hoisted_138 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Is Physically Challenged?")
], -1)
const _hoisted_139 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Select Option", -1)
const _hoisted_140 = /*#__PURE__*/_createElementVNode("option", { value: "Y" }, "Yes", -1)
const _hoisted_141 = /*#__PURE__*/_createElementVNode("option", { value: "N" }, "No", -1)
const _hoisted_142 = { class: "col-md-3" }
const _hoisted_143 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Religion", -1)
const _hoisted_144 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Select Religion", -1)
const _hoisted_145 = /*#__PURE__*/_createElementVNode("option", { value: "I" }, "Islam", -1)
const _hoisted_146 = /*#__PURE__*/_createElementVNode("option", { value: "H" }, "Hindu", -1)
const _hoisted_147 = /*#__PURE__*/_createElementVNode("option", { value: "B" }, "Christian", -1)
const _hoisted_148 = /*#__PURE__*/_createElementVNode("option", { value: "C" }, "Buddhist", -1)
const _hoisted_149 = { class: "col-md-3" }
const _hoisted_150 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Gender", -1)
const _hoisted_151 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Select Gender", -1)
const _hoisted_152 = /*#__PURE__*/_createElementVNode("option", { value: "Male" }, "Male", -1)
const _hoisted_153 = /*#__PURE__*/_createElementVNode("option", { value: "Female" }, "Female", -1)
const _hoisted_154 = /*#__PURE__*/_createElementVNode("option", { value: "Other" }, "Other", -1)
const _hoisted_155 = { class: "card mb-5 mb-xl-10" }
const _hoisted_156 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#family_information",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Family Information")
  ])
], -1)
const _hoisted_157 = {
  id: "family_information",
  class: "collapse show"
}
const _hoisted_158 = { class: "collapse show" }
const _hoisted_159 = { class: "card-body border-top p-9" }
const _hoisted_160 = { class: "row" }
const _hoisted_161 = { class: "col-md-3" }
const _hoisted_162 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Mother's Education Level", -1)
const _hoisted_163 = { class: "col-md-3" }
const _hoisted_164 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Mother's Occupation", -1)
const _hoisted_165 = { class: "col-md-3" }
const _hoisted_166 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Father's Education Level")
], -1)
const _hoisted_167 = { class: "col-md-3" }
const _hoisted_168 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Father's Occupation")
], -1)
const _hoisted_169 = { class: "row mt-3" }
const _hoisted_170 = { class: "col-md-3" }
const _hoisted_171 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Family Annual Income")
], -1)
const _hoisted_172 = { class: "col-md-3" }
const _hoisted_173 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Number of Siblings?")
], -1)
const _hoisted_174 = { class: "col-md-3" }
const _hoisted_175 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Have family owned home?", -1)
const _hoisted_176 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_177 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Select Option", -1)
const _hoisted_178 = /*#__PURE__*/_createElementVNode("option", { value: "Y" }, "Yes", -1)
const _hoisted_179 = /*#__PURE__*/_createElementVNode("option", { value: "N" }, "No", -1)
const _hoisted_180 = { class: "col-md-3" }
const _hoisted_181 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Have family owned land?", -1)
const _hoisted_182 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_183 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Select Option", -1)
const _hoisted_184 = /*#__PURE__*/_createElementVNode("option", { value: "Y" }, "Yes", -1)
const _hoisted_185 = /*#__PURE__*/_createElementVNode("option", { value: "N" }, "No", -1)
const _hoisted_186 = { class: "card mb-5 mb-xl-10" }
const _hoisted_187 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#bank_information",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, " Bank Information (Bank Account / Mobile Banking / Agent Banking) ")
  ])
], -1)
const _hoisted_188 = {
  id: "bank_information",
  class: "collapse show"
}
const _hoisted_189 = { class: "collapse show" }
const _hoisted_190 = { class: "card-body border-top p-9" }
const _hoisted_191 = { class: "row" }
const _hoisted_192 = { class: "col-md-4" }
const _hoisted_193 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Account Type", -1)
const _hoisted_194 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_195 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Select Option", -1)
const _hoisted_196 = /*#__PURE__*/_createElementVNode("option", { value: "Mobile" }, "Mobile Banking", -1)
const _hoisted_197 = /*#__PURE__*/_createElementVNode("option", { value: "Agent" }, "Agent Banking", -1)
const _hoisted_198 = { class: "col-md-4" }
const _hoisted_199 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Bank Name", -1)
const _hoisted_200 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_201 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Select Option", -1)
const _hoisted_202 = /*#__PURE__*/_createElementVNode("option", { value: "dhaka" }, "Dhaka Bank", -1)
const _hoisted_203 = /*#__PURE__*/_createElementVNode("option", { value: "islamic" }, "Islamic Bank", -1)
const _hoisted_204 = { class: "col-md-4" }
const _hoisted_205 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Branch Name", -1)
const _hoisted_206 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_207 = { class: "row mt-3" }
const _hoisted_208 = { class: "col-md-4" }
const _hoisted_209 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Routing No", -1)
const _hoisted_210 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_211 = { class: "col-md-4" }
const _hoisted_212 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Account Number", -1)
const _hoisted_213 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_214 = { class: "col-md-4" }
const _hoisted_215 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Confirm Account Number", -1)
const _hoisted_216 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_217 = { class: "d-flex" }
const _hoisted_218 = ["data-kt-indicator"]
const _hoisted_219 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_220 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_221 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_222 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Form, {
      onSubmit: _cache[6] || (_cache[6] = ($event: any) => (_ctx.formSubmit())),
      class: "form",
      "validation-schema": _ctx.TrainerSchema
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _hoisted_9,
                      _hoisted_10,
                      _createVNode(_component_Field, {
                        name: "course_sector",
                        modelValue: _ctx.trainee.course_sector,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.trainee.course_sector) = $event)),
                        class: "form-select",
                        style: {"height":"40px","width":"100%"},
                        "data-control": "select2",
                        "data-placeholder": "Select...",
                        "data-allow-clear": "true",
                        "data-hide-search": "true",
                        as: "select"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_11,
                          _hoisted_12,
                          _hoisted_13,
                          _hoisted_14,
                          _hoisted_15,
                          _hoisted_16
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "course_sector",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _hoisted_19,
                      _createVNode(_component_Field, {
                        name: "course",
                        class: "form-select",
                        modelValue: _ctx.trainee.course,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.trainee.course) = $event)),
                        style: {"height":"40px","width":"100%"},
                        "data-control": "select2",
                        "data-placeholder": "Select...",
                        "data-allow-clear": "true",
                        "data-hide-search": "true",
                        as: "select"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_20,
                          _hoisted_21,
                          _hoisted_22,
                          _hoisted_23,
                          _hoisted_24,
                          _hoisted_25,
                          _hoisted_26
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "course",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _hoisted_28,
                      _hoisted_29,
                      _createVNode(_component_Field, {
                        name: "location",
                        class: "form-select",
                        modelValue: _ctx.trainee.location,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.trainee.location) = $event)),
                        style: {"height":"40px","width":"100%"},
                        "data-control": "select2",
                        "data-placeholder": "Select...",
                        "data-allow-clear": "true",
                        "data-hide-search": "true",
                        as: "select"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_30,
                          _hoisted_31,
                          _hoisted_32,
                          _hoisted_33,
                          _hoisted_34,
                          _hoisted_35,
                          _hoisted_36
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "location",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _hoisted_39,
                      _hoisted_40,
                      _createVNode(_component_Field, {
                        name: "training_partner",
                        class: "form-select",
                        modelValue: _ctx.trainee.training_partner,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.trainee.training_partner) = $event)),
                        style: {"height":"40px","width":"100%"},
                        filterable: "",
                        "data-control": "select2",
                        "data-placeholder": "Select...",
                        "data-allow-clear": "true",
                        "data-hide-search": "true",
                        as: "select",
                        onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getEntityInfos()))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (info) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: info.id,
                              label: info.entity_name,
                              value: info.id
                            }, _toDisplayString(info.entity_name), 9, _hoisted_41))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "training_partner",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _hoisted_43,
                      _hoisted_44,
                      _createVNode(_component_Field, {
                        name: "training_institute",
                        class: "form-select",
                        modelValue: _ctx.trainee.training_institute,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.trainee.training_institute) = $event)),
                        style: {"height":"40px","width":"100%"},
                        "data-control": "select2",
                        "data-placeholder": "Select...",
                        "data-allow-clear": "true",
                        "data-hide-search": "true",
                        as: "select"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_45,
                          _hoisted_46,
                          _hoisted_47,
                          _hoisted_48
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "training_institute",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["validation-schema"]),
    _createVNode(_component_Form, {
      onSubmit: _cache[54] || (_cache[54] = ($event: any) => (_ctx.formSubmit())),
      class: "form",
      "validation-schema": _ctx.TrainerSchema
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_49, [
          _hoisted_50,
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("div", _hoisted_55, [
                    _hoisted_56,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.trainee.nid,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.trainee.nid) = $event)),
                      name: "nid",
                      class: "form-control form-control-sm",
                      style: {"height":"40px","width":"100%"}
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "nid",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_57, [
                    _hoisted_58,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.trainee.name,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.trainee.name) = $event)),
                      type: "text",
                      name: "name",
                      class: "form-control form-control-sm",
                      style: {"height":"40px","width":"100%"}
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "name",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    _hoisted_60,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.trainee.father_name,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.trainee.father_name) = $event)),
                      name: "father_name",
                      class: "form-control form-control-sm",
                      style: {"height":"40px","width":"100%"}
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "father_name",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _hoisted_62,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.trainee.mother_name,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.trainee.mother_name) = $event)),
                      name: "mother_name",
                      class: "form-control form-control-sm",
                      style: {"height":"40px","width":"100%"}
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "mother_name",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("div", _hoisted_64, [
                    _hoisted_65,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.trainee.date_of_birth,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.trainee.date_of_birth) = $event)),
                      name: "date_of_birth",
                      class: "form-control form-control-sm",
                      style: {"height":"40px","width":"100%"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_66, [
                    _hoisted_67,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.trainee.present_address,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.trainee.present_address) = $event)),
                      name: "present_address",
                      class: "form-control form-control-sm",
                      style: {"height":"40px","width":"100%"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_68, [
                    _hoisted_69,
                    _createVNode(_component_Field, {
                      name: "present_districts",
                      class: "form-select",
                      modelValue: _ctx.trainee.present_districts,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.trainee.present_districts) = $event)),
                      style: {"height":"40px","width":"100%"},
                      filterable: "",
                      "data-control": "select2",
                      "data-placeholder": "Select...",
                      "data-allow-clear": "true",
                      "data-hide-search": "true",
                      as: "select",
                      onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.getSubDistrict()))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.empDistricts, (district) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: district.id,
                            label: district.district_name_eng,
                            value: district.id
                          }, _toDisplayString(district.district_name_eng), 9, _hoisted_70))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "present_districts",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_71, [
                    _hoisted_72,
                    _createVNode(_component_Field, {
                      name: "present_upazilla",
                      class: "form-select",
                      modelValue: _ctx.trainee.present_upazilla,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.trainee.present_upazilla) = $event)),
                      style: {"height":"40px","width":"100%"},
                      filterable: "",
                      "data-control": "select2",
                      "data-placeholder": "Select...",
                      "data-allow-clear": "true",
                      "data-hide-search": "true",
                      as: "select"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subDistricts, (sub_district) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: sub_district.id,
                            label: sub_district.upazila_name_eng,
                            value: sub_district.id
                          }, _toDisplayString(sub_district.upazila_name_eng), 9, _hoisted_73))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "present_upazilla",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_74, [
                  _createElementVNode("div", _hoisted_75, [
                    _hoisted_76,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.trainee.post_code,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.trainee.post_code) = $event)),
                      name: "post_code_address",
                      class: "form-control form-control-sm",
                      style: {"height":"40px","width":"100%"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_77, [
                    _hoisted_78,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.trainee.permanent_address,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.trainee.permanent_address) = $event)),
                      name: "permanent_address",
                      class: "form-control form-control-sm",
                      style: {"height":"40px","width":"100%"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_79, [
                    _hoisted_80,
                    _createVNode(_component_Field, {
                      name: "permanent_districts",
                      class: "form-select",
                      modelValue: _ctx.trainee.permanent_districts,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.trainee.permanent_districts) = $event)),
                      style: {"height":"40px","width":"100%"},
                      filterable: "",
                      "data-control": "select2",
                      "data-placeholder": "Select...",
                      "data-allow-clear": "true",
                      "data-hide-search": "true",
                      as: "select",
                      onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.getPermanentSubDistrict()))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.empDistricts, (district) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: district.id,
                            label: district.district_name_eng,
                            value: district.id
                          }, _toDisplayString(district.district_name_eng), 9, _hoisted_81))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "permanent_districts",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_82, [
                    _hoisted_83,
                    _createVNode(_component_Field, {
                      name: "permanent_upazilla",
                      class: "form-select",
                      modelValue: _ctx.trainee.permanent_upazilla,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.trainee.permanent_upazilla) = $event)),
                      style: {"height":"40px","width":"100%"},
                      filterable: "",
                      "data-control": "select2",
                      "data-placeholder": "Select...",
                      "data-allow-clear": "true",
                      "data-hide-search": "true",
                      as: "select"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subPermanentDistrict, (subpermanent_district) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: subpermanent_district.id,
                            label: subpermanent_district.upazila_name_eng,
                            value: subpermanent_district.id
                          }, _toDisplayString(subpermanent_district.upazila_name_eng), 9, _hoisted_84))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "permanent_upazilla",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_85, [
                  _createElementVNode("div", _hoisted_86, [
                    _hoisted_87,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.trainee.trainer_image,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.trainee.trainer_image) = $event)),
                      name: "trainer_image",
                      type: "file",
                      class: "form-control"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "trainer_image",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_88, [
          _hoisted_89,
          _createElementVNode("div", _hoisted_90, [
            _createElementVNode("div", _hoisted_91, [
              _createElementVNode("div", _hoisted_92, [
                _createElementVNode("div", _hoisted_93, [
                  _createElementVNode("div", _hoisted_94, [
                    _hoisted_95,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.trainee.ref_id,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.trainee.ref_id) = $event)),
                      type: "text",
                      name: "ref_id",
                      class: "form-control form-control-sm",
                      style: {"height":"40px","width":"100%"}
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "ref_id",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_96, [
                    _hoisted_97,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.trainee.mobile,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.trainee.mobile) = $event)),
                      name: "mobile",
                      class: "form-control form-control-sm",
                      style: {"height":"40px","width":"100%"}
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "mobile",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_98, [
                    _hoisted_99,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.trainee.alt_mobile,
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.trainee.alt_mobile) = $event)),
                      name: "alt_mobile",
                      class: "form-control form-control-sm",
                      style: {"height":"40px","width":"100%"},
                      value: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_100, [
                    _hoisted_101,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.trainee.email,
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.trainee.email) = $event)),
                      name: "email",
                      class: "form-control form-control-sm",
                      style: {"height":"40px","width":"100%"}
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "email",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_102, [
                  _createElementVNode("div", _hoisted_103, [
                    _hoisted_104,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.trainee.ethnic,
                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.trainee.ethnic) = $event)),
                      name: "ethnic group",
                      class: "form-control form-control-sm",
                      style: {"height":"40px","width":"100%"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_105, [
                    _hoisted_106,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.trainee.hightest_class,
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.trainee.hightest_class) = $event)),
                      name: "hightest_class",
                      class: "form-select",
                      "data-control": "select2",
                      "data-placeholder": "Select...",
                      "data-allow-clear": "true",
                      "data-hide-search": "true",
                      as: "select",
                      style: {"height":"40px","width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_107,
                        _hoisted_108,
                        _hoisted_109,
                        _hoisted_110,
                        _hoisted_111
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_112, [
                    _hoisted_113,
                    _createVNode(_component_Field, {
                      name: "passing_year",
                      modelValue: _ctx.trainee.passing_year,
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.trainee.passing_year) = $event)),
                      class: "form-select",
                      "data-control": "select2",
                      "data-placeholder": "Select...",
                      "data-allow-clear": "true",
                      "data-hide-search": "true",
                      as: "select",
                      style: {"height":"40px","width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_114,
                        _hoisted_115,
                        _hoisted_116,
                        _hoisted_117
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "passing_year",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_118, [
                    _hoisted_119,
                    _createVNode(_component_Field, {
                      name: "is_employee",
                      modelValue: _ctx.trainee.is_employee,
                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.trainee.is_employee) = $event)),
                      class: "form-select",
                      "data-control": "select2",
                      "data-placeholder": "Select...",
                      "data-allow-clear": "true",
                      "data-hide-search": "true",
                      as: "select",
                      style: {"height":"40px","width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_120,
                        _hoisted_121,
                        _hoisted_122
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "is_employee",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_123, [
                  _createElementVNode("div", _hoisted_124, [
                    _hoisted_125,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.trainee.experience_year,
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.trainee.experience_year) = $event)),
                      name: "experience_year",
                      class: "form-control form-control-sm",
                      style: {"height":"40px","width":"100%"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_126, [
                    _hoisted_127,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.trainee.monthly_income,
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.trainee.monthly_income) = $event)),
                      name: "monthly_income",
                      class: "form-control form-control-sm",
                      style: {"height":"40px","width":"100%"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_128, [
                    _hoisted_129,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.trainee.home_district,
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.trainee.home_district) = $event)),
                      name: "home_district",
                      class: "form-select",
                      style: {"height":"40px","width":"100%"},
                      filterable: "",
                      "data-control": "select2",
                      "data-placeholder": "Loading...",
                      "data-allow-clear": "true",
                      "data-hide-search": "true",
                      as: "select",
                      onChange: _cache[33] || (_cache[33] = ($event: any) => (_ctx.getHomeDistrict()))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.empDistricts, (district) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: district.id,
                            label: district.district_name_eng,
                            value: district.id
                          }, _toDisplayString(district.district_name_eng), 9, _hoisted_130))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_131, [
                    _hoisted_132,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.trainee.home_upazilla,
                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.trainee.home_upazilla) = $event)),
                      name: "home_upazilla",
                      class: "form-select",
                      style: {"height":"40px","width":"100%"},
                      filterable: "",
                      "data-control": "select2",
                      "data-placeholder": "Select...",
                      "data-allow-clear": "true",
                      "data-hide-search": "true",
                      as: "select"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subHomePermanentDistrict, (subpermanent_district) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: subpermanent_district.id,
                            label: subpermanent_district.upazila_name_eng,
                            value: subpermanent_district.id
                          }, _toDisplayString(subpermanent_district.upazila_name_eng), 9, _hoisted_133))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_134, [
                  _createElementVNode("div", _hoisted_135, [
                    _hoisted_136,
                    _createVNode(_component_Field, {
                      name: "remarks",
                      modelValue: _ctx.trainee.remarks,
                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.trainee.remarks) = $event)),
                      class: "form-control form-control-sm",
                      style: {"height":"40px","width":"100%"}
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "remarks",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_137, [
                    _hoisted_138,
                    _createVNode(_component_Field, {
                      name: "is_physically",
                      modelValue: _ctx.trainee.is_physically,
                      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.trainee.is_physically) = $event)),
                      class: "form-select",
                      "data-control": "select2",
                      "data-placeholder": "Select...",
                      "data-allow-clear": "true",
                      "data-hide-search": "true",
                      as: "select",
                      style: {"height":"40px","width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_139,
                        _hoisted_140,
                        _hoisted_141
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "is_physically",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_142, [
                    _hoisted_143,
                    _createVNode(_component_Field, {
                      name: "religion",
                      modelValue: _ctx.trainee.religion,
                      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.trainee.religion) = $event)),
                      class: "form-select",
                      style: {"height":"40px","width":"100%"},
                      "data-control": "select2",
                      "data-placeholder": "Select...",
                      "data-allow-clear": "true",
                      "data-hide-search": "true",
                      as: "select"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_144,
                        _hoisted_145,
                        _hoisted_146,
                        _hoisted_147,
                        _hoisted_148
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "religion",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_149, [
                    _hoisted_150,
                    _createVNode(_component_Field, {
                      name: "gender",
                      modelValue: _ctx.trainee.gender,
                      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.trainee.gender) = $event)),
                      class: "form-select",
                      "data-control": "select2",
                      "data-placeholder": "Select...",
                      "data-allow-clear": "true",
                      "data-hide-search": "true",
                      as: "select",
                      style: {"height":"40px","width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_151,
                        _hoisted_152,
                        _hoisted_153,
                        _hoisted_154
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "gender",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_155, [
          _hoisted_156,
          _createElementVNode("div", _hoisted_157, [
            _createElementVNode("div", _hoisted_158, [
              _createElementVNode("div", _hoisted_159, [
                _createElementVNode("div", _hoisted_160, [
                  _createElementVNode("div", _hoisted_161, [
                    _hoisted_162,
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "mother_edu",
                      modelValue: _ctx.trainee.mother_edu,
                      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.trainee.mother_edu) = $event)),
                      class: "form-control form-control-sm",
                      style: {"height":"40px","width":"100%"}
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "mother_edu",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_163, [
                    _hoisted_164,
                    _createVNode(_component_Field, {
                      name: "mother_occ",
                      modelValue: _ctx.trainee.mother_occ,
                      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.trainee.mother_occ) = $event)),
                      class: "form-control form-control-sm",
                      style: {"height":"40px","width":"100%"}
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "mother_occ",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_165, [
                    _hoisted_166,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.trainee.father_edu,
                      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.trainee.father_edu) = $event)),
                      name: "father_edu",
                      class: "form-control form-control-sm",
                      style: {"height":"40px","width":"100%"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_167, [
                    _hoisted_168,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.trainee.father_occ,
                      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.trainee.father_occ) = $event)),
                      name: "father_occ",
                      class: "form-control form-control-sm",
                      style: {"height":"40px","width":"100%"}
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_169, [
                  _createElementVNode("div", _hoisted_170, [
                    _hoisted_171,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.trainee.family_income,
                      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.trainee.family_income) = $event)),
                      name: "family_income",
                      class: "form-control form-control-sm",
                      style: {"height":"40px","width":"100%"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_172, [
                    _hoisted_173,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.trainee.sibling_no,
                      "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.trainee.sibling_no) = $event)),
                      name: "sibling_no",
                      class: "form-control form-control-sm",
                      style: {"height":"40px","width":"100%"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_174, [
                    _hoisted_175,
                    _hoisted_176,
                    _createVNode(_component_Field, {
                      name: "family_own_home",
                      modelValue: _ctx.trainee.family_own_home,
                      "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.trainee.family_own_home) = $event)),
                      class: "form-select",
                      "data-control": "select2",
                      "data-placeholder": "Select...",
                      "data-allow-clear": "true",
                      "data-hide-search": "true",
                      as: "select",
                      style: {"height":"40px","width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_177,
                        _hoisted_178,
                        _hoisted_179
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "family_own_home",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_180, [
                    _hoisted_181,
                    _hoisted_182,
                    _createVNode(_component_Field, {
                      name: "family_own_land",
                      modelValue: _ctx.trainee.family_own_land,
                      "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.trainee.family_own_land) = $event)),
                      class: "form-select",
                      "data-control": "select2",
                      "data-placeholder": "Select...",
                      "data-allow-clear": "true",
                      "data-hide-search": "true",
                      as: "select",
                      style: {"height":"40px","width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_183,
                        _hoisted_184,
                        _hoisted_185
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "family_own_land",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_186, [
          _hoisted_187,
          _createElementVNode("div", _hoisted_188, [
            _createElementVNode("div", _hoisted_189, [
              _createElementVNode("div", _hoisted_190, [
                _createElementVNode("div", _hoisted_191, [
                  _createElementVNode("div", _hoisted_192, [
                    _hoisted_193,
                    _hoisted_194,
                    _createVNode(_component_Field, {
                      name: "bank_account_type",
                      modelValue: _ctx.trainee.bank_account_type,
                      "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.trainee.bank_account_type) = $event)),
                      class: "form-select",
                      "data-control": "select2",
                      "data-placeholder": "Select...",
                      "data-allow-clear": "true",
                      "data-hide-search": "true",
                      as: "select"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_195,
                        _hoisted_196,
                        _hoisted_197
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "bank_account_type",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_198, [
                    _hoisted_199,
                    _hoisted_200,
                    _createVNode(_component_Field, {
                      name: "moblie_bank",
                      modelValue: _ctx.trainee.moblie_bank,
                      "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.trainee.moblie_bank) = $event)),
                      class: "form-select",
                      "data-control": "select2",
                      "data-placeholder": "Select...",
                      "data-allow-clear": "true",
                      "data-hide-search": "true",
                      as: "select",
                      style: {"height":"40px","width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_201,
                        _hoisted_202,
                        _hoisted_203
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "moblie_bank",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_204, [
                    _hoisted_205,
                    _hoisted_206,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.trainee.branchName,
                      "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.trainee.branchName) = $event)),
                      type: "text",
                      name: "branchName",
                      class: "form-control form-control-sm",
                      style: {"height":"40px","width":"100%"}
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "branchName",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_207, [
                  _createElementVNode("div", _hoisted_208, [
                    _hoisted_209,
                    _hoisted_210,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.trainee.routingNo,
                      "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.trainee.routingNo) = $event)),
                      type: "text",
                      name: "routingNo",
                      class: "form-control form-control-sm",
                      style: {"height":"40px","width":"100%"}
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "routingNo",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_211, [
                    _hoisted_212,
                    _hoisted_213,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.trainee.account_no,
                      "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.trainee.account_no) = $event)),
                      type: "text",
                      name: "account_no",
                      class: "form-control form-control-sm",
                      style: {"height":"40px","width":"100%"}
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "account_no",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_214, [
                    _hoisted_215,
                    _hoisted_216,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.trainee.confirmaccount_no,
                      "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.trainee.confirmaccount_no) = $event)),
                      type: "text",
                      name: "confirmaccount_no",
                      class: "form-control form-control-sm",
                      style: {"height":"40px","width":"100%"}
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "confirmaccount_no",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_217, [
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                "data-kt-indicator": _ctx.loading ? 'on' : null,
                class: "btn btn-lg btn-success",
                type: "submit",
                onClick: _cache[53] || (_cache[53] = ($event: any) => (_ctx.formSubmit()))
              }, [
                (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_219, [
                      _createTextVNode(" Submit "),
                      _createElementVNode("span", _hoisted_220, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_221, [
                      _createTextVNode(" Please wait... "),
                      _hoisted_222
                    ]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_218)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["validation-schema"])
  ], 64))
}